import { render, staticRenderFns } from "./sysTicket.vue?vue&type=template&id=208f126e&scoped=true&"
import script from "./sysTicket.vue?vue&type=script&lang=js&"
export * from "./sysTicket.vue?vue&type=script&lang=js&"
import style0 from "./sysTicket.vue?vue&type=style&index=0&id=208f126e&lang=scss&scoped=true&"
import style1 from "./sysTicket.vue?vue&type=style&index=1&id=208f126e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208f126e",
  null
  
)

export default component.exports